"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UserFlag;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = require("@insided/shared/utils/globals");

var _toKebabCase = require("@insided/shared/utils/toKebabCase");

var _userAvatar = require("@insided/shared/utils/userAvatar");

function UserFlag(_ref) {
  var pmNotificationHref = _ref.pmNotificationHref,
      pmUnreadCount = _ref.pmUnreadCount,
      size = _ref.size,
      id = _ref.id,
      avatar = _ref.avatar,
      rankIcon = _ref.rankIcon,
      rankName = _ref.rankName,
      name = _ref.name;
  var showPmBadge = !!pmNotificationHref && pmUnreadCount > 0;
  return (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (modules) {
    return (0, _preact.h)("div", {
      className: "user flag"
    }, (0, _preact.h)("div", {
      className: "flag__image"
    }, (0, _preact.h)("div", {
      className: "avatar avatar--".concat(size !== null && size !== void 0 ? size : 'S')
    }, (0, _preact.h)("a", {
      href: (0, _absoluteUrlRuntime.resolveUrl)("/members/".concat((0, _toKebabCase.textToKebab)(name), "-").concat(id)),
      className: "qa-profilepicture"
    }, (0, _preact.h)("div", {
      className: "profilepicture profile--dropdown-trigger"
    }, avatar ? (0, _preact.h)("img", {
      src: (0, _absoluteUrlRuntime.resolveUrl)(avatar.replace('90x90', '100x100')),
      alt: name
    }) : (0, _preact.h)("div", {
      className: "default-avatar avatar-variant-".concat((id !== null && id !== void 0 ? id : 0) % 10)
    }, (0, _userAvatar.getAvatarInitial)(name))), modules.includes('rank') && rankIcon && (0, _preact.h)("div", {
      className: "profilelabel"
    }, (0, _preact.h)("img", {
      src: (0, _absoluteUrlRuntime.resolveUrl)(rankIcon),
      title: rankName,
      alt: rankName
    })))), showPmBadge && (0, _preact.h)("a", {
      className: "flag-notification",
      href: (0, _absoluteUrlRuntime.resolveUrl)(pmNotificationHref)
    }, pmUnreadCount)));
  });
}